export default "__VITE_ASSET__DloVG5Up__"